import axios from 'axios';
import cookie from '../../cookieHelper/cookie';

export default async function getStoryByID(storyId) {
    const API_URL = process.env.REACT_APP_BASE_URL + '/api/v1/story/' + storyId;
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);

    try {
        const res = await axios.get(API_URL, {
            headers: {
                Authorization: `Bearer ${authToken}`,
            }
        });
        // console.log("res: ", res);
        return res.data;
    } catch (err) {
        // console.log("err: ", err);
        throw err; // Re-throw the error to allow handling it in the caller
    }
}
